import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux"; // préparé pour intégration store

const daysOfWeek = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];

const Calendar = ({ dateSelectionnee, setDateSelectionne, disponibilite, onMonthChange }) => {
  const today = dateSelectionnee ? new Date(dateSelectionnee) : new Date();
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [selectedDate, setSelectedDate] = useState(
    Number.isFinite(today.getDate()) ? today.getDate() : null
  );

  useEffect(() => {
    if (!dateSelectionnee) return;
    const dateObj =
      dateSelectionnee instanceof Date
        ? dateSelectionnee
        : new Date(dateSelectionnee);
    if (Number.isNaN(dateObj.getTime())) return;
    setCurrentMonth(dateObj.getMonth());
    setCurrentYear(dateObj.getFullYear());
    setSelectedDate(dateObj.getDate());
  }, [dateSelectionnee]);

  // Couleurs (placeholder – à remplacer par useSelector plus tard)
  const colors = useSelector((state) => state.colors) || {
    cloture: "bg-gray-400",
    complet: "bg-red-500",
    limite: "bg-orange-400",
    libre: "bg-green-500",
  };

  const handleMonthChange = (delta) => {
    const newDate = new Date(currentYear, currentMonth + delta, 1);
    setCurrentMonth(newDate.getMonth());
    setCurrentYear(newDate.getFullYear());
    if (typeof onMonthChange === "function") {
      onMonthChange({
        year: newDate.getFullYear(),
        month: newDate.getMonth() + 1,
      });
    }
  };

  const handlePrevMonth = () => handleMonthChange(-1);

  const handleNextMonth = () => handleMonthChange(1);

  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const firstDay = (new Date(currentYear, currentMonth, 1).getDay() + 6) % 7; // décalage pour commencer lundi

  const days = [];
  for (let i = 0; i < firstDay; i++) days.push(null);
  for (let i = 1; i <= daysInMonth; i++) days.push(i);

  // Exemple de mapping aléatoire (sera remplacé par données du store)
  const getStatusColor = (day) => {
    if (!day) return "";
    const sample = ["cloture", "complet", "limite", "libre"];

    const data = disponibilite.filter(dispo => new Date(dispo.date).getDate() === day )[0]

    if (!data || data.places === 0) 
        return colors['cloture'];
    if (!data || data.places < 5) 
        return colors['limite'];

    return colors['libre'];

  };

  const handleSelectDay = (day) => {
    if (!day) return;    
    let date = `${String(currentYear).padStart(2, "0")}-${String(currentMonth + 1).padStart(2, "0")}-${String(day).padStart(2,"0")}T00:00:00`
    date = new Date(date)

    setSelectedDate(day);
    setDateSelectionne(date);
  };

  const monthNames = [
    "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
    "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre",
  ];

  return (
    <div className="w-full max-w-3xl mx-auto bg-white rounded-xl shadow-lg p-6 flex flex-col h-full">
      {/* Header Mois - Année */}
      <div className="flex items-center justify-between mb-6">
        <button
          onClick={handlePrevMonth}
          className="px-3 py-1 text-gray-700 text-xl font-bold hover:text-orange-600"
        >
          ←
        </button>
        <h2 className="text-2xl font-semibold text-gray-800">
          {monthNames[currentMonth]} {currentYear}
        </h2>
        <button
          onClick={handleNextMonth}
          className="px-3 py-1 text-gray-700 text-xl font-bold hover:text-orange-600"
        >
          →
        </button>
      </div>

      {/* Jours de la semaine */}
      <div className="grid grid-cols-7 text-center font-semibold text-gray-600 mb-2">
        {daysOfWeek.map((day) => (
          <div key={day}>{day}</div>
        ))}
      </div>

      {/* Jours du mois */}
      <div className="grid grid-cols-7 gap-2 text-center flex-1">
        {days.map((day, idx) => (
          <div
            key={idx}
            onClick={() => handleSelectDay(day)}
            className={`relative flex items-center justify-center h-12 cursor-pointer 
            ${day ? "hover:bg-gray-100" : ""} 
            ${selectedDate === day ? "border-2 border-orange-200 rounded-lg" : ""}`}
          >
            {day && (
              <div
                className={`absolute w-8 h-8 rounded-full ${getStatusColor(day)} opacity-40`}
              ></div>
            )}
            <span className="relative z-10 font-medium">{day}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Calendar;
